export default {
    fillLabel: 'Заливка',
    fillIcon: `
    <g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em">
        <g transform="rotate(60, 12, 12)">
            <rect x="4" y="4" width="14" height="16" rx="3"/>
        </g>
        <path d="M21 13 L21 21"></path>
        <path d="M4.5 12.5 L19 12.5"></path>
    </g>
    `,
};
